module.exports = __webpack_public_path__ + "static/media/19ESCAP47.2d8116c0.jpg";